import rest from "../script/rest";

class CompanyRest {

    async getAll() {
        const url = "/rest/company/getAll";
        const response = await rest.get(url);
        return response.json();
    }
}
const companyRest = new CompanyRest();
window.companyRest = companyRest;
export default companyRest;